export default __webpack_public_path__ + "static/media/scrabble-2048w.d06f8dc7.avif";